<script>
    import "../../../../../app.css";
    import AdvantagesItem from "./advantages-item.svelte";
    import { t } from "$lib/i18n.js";
</script>

<section>
    <div>
        <h2>{$t('routes.owner.advantages.title')}</h2>
        <h2 class="orange">{$t('routes.owner.advantages.title_accent')}</h2>
    </div>

    <div class="steps">
        <div class="items">
            <AdvantagesItem headline="{$t('routes.owner.advantages.cols.1.headline')}" subheadline="{$t('routes.owner.advantages.cols.1.subheadline')}" icon='🔒'/>
            <AdvantagesItem headline="{$t('routes.owner.advantages.cols.2.headline')}" subheadline="{$t('routes.owner.advantages.cols.2.subheadline')}" icon='🫶'/>
            <AdvantagesItem headline="{$t('routes.owner.advantages.cols.3.headline')}" subheadline="{$t('routes.owner.advantages.cols.3.subheadline')}" icon='🤝'/>    
        </div>
        <div class="items">
            <AdvantagesItem headline="{$t('routes.owner.advantages.cols.4.headline')}" subheadline="{$t('routes.owner.advantages.cols.4.subheadline')}" icon='📈'/>
            <AdvantagesItem headline="{$t('routes.owner.advantages.cols.5.headline')}" subheadline="{$t('routes.owner.advantages.cols.5.subheadline')}" icon='✅'/>    
        </div>
    </div>
</section>

<style>
    section {
        background: var(--surface-container);
        padding-top: 140px;
        padding-bottom: 140px;
        padding-left: 16px;
        padding-right: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 40px;
    }

    h2 {
        margin: 0;
        padding: 0;
        text-align: center;
        font-family: var(--font-body);
    }

    h2.orange {
        color: var(--orange);
        font-family: var(--font-heading);
        margin-top: 8px;
    }

    .steps {
        max-width: var(--max-width);
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 32px;
    }

    .steps .items {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        gap: 40px;
    }

    @media (max-width: 768px) {
        .steps .items {
            flex-direction: column;
            align-items: center;
        }
    }
</style>
